import type { Route } from '@angular/router';

export const appRoutes: Route[] = [
    {
        loadComponent: async () => import('./pages/home-page').then((m) => m.HomePage),
        path: '',
    },
    {
        loadComponent: async () => import('./pages/join-page').then((m) => m.JoinPage),
        path: 'join',
    },
    {
        loadChildren: async () => import('./setup.routes').then((module) => module.SETUP_APP_ROUTES),
        path: 'setup',
    },
    {
        loadChildren: async () => import('./game.routes').then((module) => module.GAME_ROUTES),
        path: 'game/:gameId',
    },
    {
        loadChildren: async () => import('@animus/rules/feature').then((m) => m.RULES_ROUTES),
        path: 'library/rules',
    },
    {
        loadChildren: async () => import('@animus/datasheets/feature').then((m) => m.LIBRARY_ROUTES),
        path: 'library/factions',
    },
    {
        loadChildren: async () => import('@animus/custom-spawn/feature').then((m) => m.CUSTOM_SPAWN_ROUTES),
        path: 'library/custom-spawn',
    },
    {
        loadChildren: async () => import('@animus/supply/feature').then((m) => m.RESUPPLY_TABLE_ROUTES),
        path: 'library/resupply-table',
    },
    {
        loadComponent: async () =>
            import('./pages/datasheet-card-preview-page').then((m) => m.DatasheetCardPreviewPage),
        path: 'library/datasheet-card-preview',
    },
    {
        loadComponent: async () => import('./pages/about-page').then((m) => m.AboutPage),
        path: 'about',
    },
    {
        loadComponent: async () => import('./pages/settings-page').then((m) => m.SettingsPage),
        path: 'settings',
    },
    {
        loadComponent: async () => import('./pages/not-found-page').then((m) => m.NotFoundPage),
        path: '**',
    },
];
